// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".liste_dispo_remplacant[data-v-0f8b0f1b]{max-height:calc(100vh - 270px);min-height:calc(100vh - 270px);overflow-y:auto;overflow-x:hidden}.message_astreinte_detail[data-v-0f8b0f1b]{min-height:24px}", ""]);
// Exports
module.exports = exports;
